module.exports = __webpack_public_path__ + "media/images/flags/32/Swaziland-ad5b85c37bb1d30ae7a2c1bd6692546e.png";